module.exports = __webpack_public_path__ + "media/images/version_merge/head_logo-ee1c912b87bf1be92e542037811a08ae.svg";